import React from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles'
import { partial } from 'lodash';
import DragCanvas, { DragCanvasImage } from '@dyl/components/DragCanvas';
import ImagePicker from '@dyl/components/ImagePicker';
import useTaskField from '@dyl/pages/Tasks/edit/useTaskField';
import { useImage } from '@dyl/systems/ImagesManager';
import PreviousImages from './utils/PreviousImages';

const useStyles = makeStyles(theme => ({
    pickersContainer: {
        marginBottom: '8px',
        maxWidth: theme.breakpoints.values.md,
    },
}))

export default function DifferenceEditor(
    {
        index,
        draggable = true,
        ...other
    }) {
    const classes = useStyles();

    const [backgroundImageId] = useTaskField('items', index, 'answers', 0, 'image_id');
    const { src: backgroundImageSrc } = useImage(backgroundImageId);

    return (
        <>
            <Grid container className={classes.pickersContainer} spacing={2}>
                <Grid item xs={12} sm={6} md={4} >
                    <ImagePickerContainer itemIndex={index} label='Background Image' fieldName='image_id'/>
                </Grid>
                <Grid item xs={12} sm={6} md={4} >
                    <ImagePickerContainer itemIndex={index} label='Arrow Image' fieldName='placement_image_id'/>
                </Grid>
            </Grid>

            <DragCanvas backgroundSrc={backgroundImageSrc}>
                <PreviousImages index={index} />
                <Draggable
                    itemIndex={index}
                    disabled={!draggable}
                    imageFieldName='placement_image_id'
                />
            </DragCanvas>
        </>
    );
}

function ImagePickerContainer({ itemIndex, label, fieldName = 'image_id' }) {
    const useField = partial(useTaskField, 'items', itemIndex, 'answers', 0);
    const [imageId, setImageId, imageError] = useField(fieldName);

    return (
        <>
            <ImagePicker
                label={label}
                value={imageId}
                onChange={setImageId}
                fullWidth
                error={!!imageError}
                helperText={imageError}
                allowEmpty
            />
        </>
    );
}

export function Draggable({ itemIndex, disabled = false, imageFieldName = 'image_id' }) {
    const useField = partial(useTaskField, 'items', itemIndex, 'answers', 0);
    const [imageId] = useField(imageFieldName);
    const { src } = useImage(imageId);
    const [coordinates, setCoordinates] = useField('coordinates');

    return (
        <DragCanvasImage
            disabled={disabled}
            src={src}
            alt={imageId}
            coordinates={coordinates}
            onCoordinatesChange={setCoordinates}
        />
    );
}